<h1 class="text-white text-lg font-semibold mb-4">Importador Masivo de Datos</h1>
<div class="p-4 bg-gray-800 rounded-md shadow-md">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Seleccionar Colección</mat-label>
            <mat-select [(ngModel)]="selectedCollection" name="selectedCollection">
                <mat-option *ngFor="let col of collections" [value]="col.value">{{ col.viewValue }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div>
            <input type="file" (change)="onFileSelected($event)" accept=".xlsx, .xls, .csv">
            <p *ngIf="selectedFile" class="text-white mt-2">Archivo seleccionado: {{ selectedFile.name }}</p>
        </div>
        <div class="col-span-full mt-4">
            <button mat-flat-button color="primary" (click)="importExcelData()" [disabled]="!selectedFile || !selectedCollection">Importar Datos desde Excel</button>
        </div>
    </div>
</div>
<p class="text-white mt-4">
    <strong class="text-red-500">¡ADVERTENCIA!</strong> Esta herramienta importa datos masivamente.
    Asegúrese de que el archivo Excel contenga las columnas exactas que la función de Cloud espera para la creación de documentos en la colección seleccionada.
    Úselo con precaución y preferiblemente en entornos de desarrollo.
</p>